<adapt-catchups-page-content *ngIf="person"
                             [person]="person"></adapt-catchups-page-content>
